import styled from '@emotion/styled';

export const MainBlock = styled.div`
  /* Use internal padding instead of external margin to avoid parent overflow */
  box-sizing: border-box;
  margin: 24px 24px 0 24px;

  /* Fill the parent height without causing extra scroll on the parent */
  height: calc(100% - 24px);

  /* Use grid to allocate header area and a growing body */
  display: grid;
  grid-template-rows: auto 1fr;
`;
